/**
 * The one compliance grade scale (COM-564). The visit detail page, the
 * dashboard, Comprehend Live and the workspace all read their letter and
 * colour from here, so they cannot drift apart again (they had: the
 * dashboard was A >= 75, B 50-74, C < 50, with no F).
 *
 * Bands, inclusive of their lower bound: A >= 80, B 60-79, C 50-59, F < 50.
 * There is no D. The Chrome extension's in-EMR rail keeps its own copy
 * (ComplianceRail.ts scoreToGrade -- the content script cannot import the
 * React app) and the backend has Support/ComplianceGrades.py; change all
 * three together.
 */
export const GRADE_BANDS = [
  { grade: 'A', min: 80 },
  { grade: 'B', min: 60 },
  { grade: 'C', min: 50 },
  { grade: 'F', min: -Infinity },
];

/** The letter for a score that exists, 0 included (an average of 0 is an F). */
export const gradeForScore = (score) =>
  GRADE_BANDS.find((band) => Number(score) >= band.min).grade;

/** The letter for a note's score, '--' when it has none (null, undefined or 0). */
export const scoreToGrade = (score) => (!score ? '--' : gradeForScore(score));

/** Each letter's colour where a grade is drawn as text. */
export const GRADE_TEXT_COLORS = { A: '#6bd888', B: 'orange', C: '#FACC15', F: 'red' };

/** Badge colour for a score: green A, amber B and C, red F. */
export const scoreBadgeColor = (score) => {
  const grade = gradeForScore(score);
  if (grade === 'A') return 'success';
  if (grade === 'F') return 'danger';
  return 'warning';
};
